module.exports = __webpack_public_path__ + "img/soil-station.ccdbb266.jpg";